import axios from "axios";
import router from "../router";

const $axios = axios.create({
  baseURL:
    process.env.VUE_APP_API_BASE_URL !== undefined
      ? process.env.VUE_APP_API_BASE_URL
      : "http://localhost:8000/api/v2/",
});

$axios.CancelToken = axios.CancelToken;
$axios.isCancel = axios.isCancel;

$axios.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = token;
    }

    return config;
  },

  (error) => {
    return Promise.reject(error);
  }
);

$axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log(error.response.status);
    if (401 === error.response.status) {
      console.log(router.currentRoute);
      if (
        router.currentRoute.name != "Root" &&
        router.currentRoute.name != "Login"
      ) {
        localStorage.removeItem('token')
        router.push({ name: "Root" });
      }
    } else {
      return Promise.reject(error);
    }
  }
);

export default $axios;
